import React from 'react';
import type { RunSummary } from '@root/lib';
import { formatMoney } from '@shared/lib';
import { useTranslation } from 'react-i18next';
import { runResultLabel, signedMoney } from './runLabels';
import styles from './RunList.module.scss';

interface RunCardProps {
  run: RunSummary;
  symbol: string;
  onView: (run: RunSummary) => void;
}

// The same run, stacked, for widths that can't hold the table.
const RunCard: React.FC<RunCardProps> = ({ run, symbol, onView }) => {
  const { t } = useTranslation();
  const net = formatMoney(symbol, Math.abs(run.net));

  return (
    <button type="button" className={styles.card} onClick={() => onView(run)}>
      <span className={styles.cardHead}>
        {run.roundLabel} · {runResultLabel(run.result, t)}
      </span>
      <span className={styles.cardTime}>
        {new Date(run.startedAt).toLocaleString(undefined, {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })}
      </span>
      <span className={styles.cardLine}>
        {t('Roll {{amount}}', { amount: formatMoney(symbol, run.rollAmount) })}
        {'  ·  '}
        {t('Spent {{amount}}', { amount: formatMoney(symbol, run.totalSpent) })}
      </span>
      <span className={styles.cardLine}>
        {t('Multipliers collected: {{multipliers}}', {
          multipliers: run.topMultiplier ? `${run.topMultiplier}X` : '—',
        })}
      </span>
      <span className={styles.cardTotals}>
        {t('Total win {{amount}}', {
          amount: formatMoney(symbol, run.totalWin),
        })}
        {'  ·  '}
        {t('Net {{amount}}', { amount: signedMoney(net, run.net) })}
      </span>
      <span className={styles.cardAction}>{t('View details →')}</span>
    </button>
  );
};

export default RunCard;
